// extracted by mini-css-extract-plugin
export default {"wrapper":"Background_wrapper__iikb+"};